<dialog
  #dialog
  qai-dialog
  [heading]="''"
  [description]="''"
  [showClose]="true"
  (closeButtonClicked)="onClose()"
>
  <div class="screenshare-unsupported">
    <div class="screenshare-unsupported__icon">
      <qai-icon kind="alert-circle" size="24px"></qai-icon>
    </div>
    <div class="screenshare-unsupported__title">
      {{ 'call.SCREENSHARE_UNSUPPORTED_TITLE' | transloco: { callName: callName() } }}
    </div>
    <div class="screenshare-unsupported__message">
      {{ 'call.' + messageKey | transloco }}
    </div>
    <div class="screenshare-unsupported__actions">
      <button qai-button type="button" size="large" kind="secondary" (click)="onClose()">
        {{ 'call.SCREENSHARE_UNSUPPORTED_CLOSE_BUTTON' | transloco }}
      </button>
      <button
        #goToAppRef
        qai-button
        type="button"
        size="large"
        kind="primary"
        class="screenshare-unsupported__go-to-app--disabled"
        aria-disabled="true"
        (click)="onGoToApp()"
      >
        {{ 'call.SCREENSHARE_UNSUPPORTED_GO_TO_APP_BUTTON' | transloco }}
      </button>
      <qai-tooltip
        [qaiFloating]="goToAppRef.elementRef.nativeElement"
        [placement]="'below-center'"
        [events]="['click']"
        (opened)="scheduleGoToAppTooltipAutoHide()"
      >
        {{ 'call.SCREENSHARE_UNSUPPORTED_GO_TO_APP_UNAVAILABLE' | transloco }}
      </qai-tooltip>
    </div>
  </div>
</dialog>
